/**
 * @override
 * Override standard fragment to include content field with links.
 * Links are needed to render embedded entries/assets in rich text.
 */

import gql from 'graphql-tag';

import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const RichTextBlockFragment = gql`
  ${BaseImageFragment}
  ${BaseRichTextBlockFragment}
  ${BaseVideoFragment}

  fragment RichTextBlockFragment on RichTextBlock {
    ...BaseRichTextBlockFragment

    content {
      json
      links {
        entries {
          block {
            __typename
            sys {
              id
            }
          }
        }
        assets {
          block {
            sys {
              id
            }
            contentType
            description
            fileName
            height
            width
            size
            title
            url
          }
        }
      }
    }
    image {
      ... on Image {
        ...BaseImageFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
    }
  }
`;
